import React, { useState, useEffect } from 'react';

const containerStyle = {
  background: "transparent",
  borderRadius: '10px',
};

const buttonGroupStyle = {
  display: 'flex',
  flexDirection: 'row',
  gap: '16px', // Space between buttons
  //marginTop: '10px',
  width: '100%',
  justifyContent: 'flex-start',
};

const buttonStyle = {
  padding: '10px 5px',
  fontSize: '16px',
  borderRadius: '4px',
  border: 'none',
  cursor: 'pointer',
  width: '150px', // Fixed width for buttons
  marginBottom: '0px',
  marginLeft: '0px',
  marginRight: '0px',
  backgroundColor: '#926F34',
  color: 'black',
};

const inputStyle = {
  width: '100%',
  height: '40px',
  padding: '10px',
  fontSize: '16px',
  borderRadius: '4px',
  border: '1px solid #ccc',
  marginBottom: '5px',
};


const Addresses = () => {
  const [isEditing, setIsEditing] = useState(false);
  const [addresses, setAddresses] = useState(['1020, Tritera, New York City']);
  const userID = localStorage.getItem('userID');
  const userName = localStorage.getItem('username');

  // Fetch addresses on mount
  useEffect(() => {
    const fetchAddresses = async () => {
      try {
        const response = await fetch(`https://xianhefairy.com/LotusFairy_API/api/Booking/getAddress?ID=${userID}`);
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        const data = await response.json();
        if (data.length > 0) {
          const { ADDRESS_FIRST, ADDRESS_SECOND, ADDRESS_THIRD } = data[0];
          setAddresses([ADDRESS_FIRST, ADDRESS_SECOND, ADDRESS_THIRD].filter(Boolean)); // Filter out empty addresses
        }
      } catch (error) {
        console.error('Error fetching addresses:', error);
      }
    };

    fetchAddresses();
  }, [userID]);

  const handleEditToggle = () => {
    setIsEditing((prev) => !prev);
  };

  const handleAddressChange = (index, value) => {
    const newAddresses = [...addresses];
    newAddresses[index] = value;
    setAddresses(newAddresses);
  };

  const handleAddAddress = () => {
    if (addresses.length < 3) {
      setAddresses([...addresses, '']);
    }
  };

  const handleRemoveAddress = (index) => {
    const newAddresses = addresses.filter((_, i) => i !== index);
    setAddresses(newAddresses);
  };

  const handleSaveAddresses = async () => {
    const requestBody = {
      ID: userID,
      addFirst: addresses[0] || null,
      addSecond: addresses[1] || null,
      addThird: addresses[2] || null,
    };

    try {
      const response = await fetch('https://xianhefairy.com/LotusFairy_API/api/user/UpdateAddress', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(requestBody),
      });

      if (!response.ok) {
        throw new Error('Network response was not ok');
      }

      const data = await response.json();
      console.log('Success:', data); // Handle success response
      setIsEditing((prev) => !prev);
    } catch (error) {
      console.error('Error:', error); // Handle error
    }
  };
  const isMobile = window.innerWidth <= 768;

  return (
    <div style={containerStyle}>
      <div>
        <strong style={{color: "black"}}>Addresses:</strong>
        {!isEditing && (
          <span
            style={{
              color: "#000",
              textDecoration: "underline",
              cursor: "pointer",
              marginLeft: "10px",
              fontWeight: "bold",
            }}
            onClick={handleEditToggle}
          >
            Change address (click here)
          </span>
        )}
        {addresses.map((address, index) => (
          <div key={index} style={{ marginBottom: '10px' }}>
            {isEditing ? (
              <>
                <input
                  type="text"
                  value={address}
                  onChange={(e) => handleAddressChange(index, e.target.value)}
                  placeholder={`Address ${index + 1}`}
                  style={inputStyle}
                />
                {addresses.length > 1 && (
                  <button
                    style={{
                      ...buttonStyle,
                      backgroundColor: '#dc3545',
                      color: 'white',
                      width: '120px',
                      marginLeft: '10px',
                    }}
                    onClick={() => handleRemoveAddress(index)}
                  >
                    Remove
                  </button>
                )}
              </>
            ) : (
              <p style={{color: "black"}}>{address}</p>
            )}
          </div>
        ))}

        {isEditing && (
          <div style={buttonGroupStyle}>
            <button
              style={buttonStyle}
              onClick={handleSaveAddresses}
            >
              Save
            </button>

            {addresses.length < 3 && (
              <button
                style={buttonStyle}
                onClick={handleAddAddress}
              >
                Add Address
              </button>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default Addresses;
